
// export const CORE_API_ENDPOINT = 'http://localhost:2000'

export const CORE_API_ENDPOINT = '/api'
// 
// export const CORE_API_ENDPOINT = 'https://tbqapi.rmbainisys.com'



// WEBPACK FOOTER //
// ./src/lib/api.js